

export class VehicleGroupIdDataInput implements IVehicleGroupIdDataInput {
    /** The auto-generated id of the vehicle group master */
    vehicleGroupId!: number;

    constructor(data?: IVehicleGroupIdDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleGroupId = _data["vehicleGroupId"];
        }
    }

    static fromJS(data: any): VehicleGroupIdDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleGroupIdDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleGroupId"] = this.vehicleGroupId;
        return data; 
    }
}

export interface IVehicleGroupIdDataInput {
    /** The auto-generated id of the vehicle group master */
    vehicleGroupId: number;
}

